module.exports = __webpack_public_path__ + "static/media/chart-area.049830ae.svg";